var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPostAlbumOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 2.5H2.5V8.33333H8.33333V2.5Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5H11.6666V8.33333H17.5V2.5Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6667H11.6666V17.5H17.5V11.6667Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 11.6667H2.5V17.5H8.33333V11.6667Z",
    fill: "#DBDBDB",
    stroke: "#DBDBDB",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostAlbumOff);
export default __webpack_public_path__ + "static/media/icon-post-album-off.e15c74fa7c81e856013d5f3640052873.svg";
export { ForwardRef as ReactComponent };